/***
 * @file:
 * @author: caojianping
 * @Date: 2021-05-25 15:09:15
 */
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  constructor() {}

  private toggleLoading = new Subject();

  // è·å¾ä¸ä¸ªObservable
  $toggle = this.toggleLoading.asObservable();

  /**
   * @param bool æ¾ç¤º/éèå¨ç»flag
   */
  emitToggle(bool: boolean = false) {
    this.toggleLoading.next(bool);
  }
}
